import React from 'react';
import { IconButton, Link, LinkProps, Modal, styled, Toolbar } from '@mui/material';
import { CloseOutlined } from '@mui/icons-material';
import { useNavigatorOnLine } from '../../hooks/useNavigatorOnline';
import { useLocation } from 'react-router-dom';
import { useServiceProvider } from '../../Providers';

const StyledModal = styled(Modal)(({ theme }) => ({
  background: 'rgba(0, 0, 0, 0.8)',
}));

const ModalContent = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
});

const AudioWrapper = styled('div')({
  flexGrow: 1,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: theme.palette.common.white,
}));

export const Mp3ReadyLink = (props: LinkProps) => {
  const { navigationService } = useServiceProvider();

  const location = useLocation<{ mp3?: string }>();
  const open = location.state?.mp3 === props.href;

  const online = useNavigatorOnLine();

  const handleClick = (event: React.MouseEvent<HTMLAnchorElement>) => {
    event.preventDefault();
    navigationService.navigate(location.pathname, { state: { mp3: props.href } });
  };

  const handleClose = () => {
    navigationService.goBack();
  };

  return (
    <>
      {online ? <Link {...props} onClick={handleClick} /> : <Link {...props} />}
      {online && (
        <StyledModal open={open} onClose={handleClose}>
          <ModalContent>
            <Toolbar sx={{ justifyContent: 'flex-end' }}>
              <StyledIconButton onClick={handleClose}>
                <CloseOutlined />
              </StyledIconButton>
            </Toolbar>
            <AudioWrapper>
              <audio controls src={props.href}>
                Your browser does not support the audio element.
              </audio>
            </AudioWrapper>
          </ModalContent>
        </StyledModal>
      )}
    </>
  );
};
